<template>
  <div v-if="currentRoles.name === '权限管理'" class="page-index user-index">
    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
       <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="50">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="id"
          label="Id">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="name"
          label="权限名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="parentId"
          label="节点ID">
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { mapGetters } from 'vuex'
  import { formatDate } from '../../utils/common'
  import { apiDelete, apiEdit, apiGetList, apiDetail } from '../../api/module'

  export default {
    mixins: [tableMixin],
    name: 'power',
    data() {
      return {
        list: [],
        pageIndex: 1,
        total: 0
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      this._getList()
    },
    methods: {
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 获取列表
      _getList(pageIndex = 1) {
        apiGetList(this.query, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.user-index
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
